<div [formGroup]="form" fxLayout="column" fxLayoutGap="8px">
	<mat-form-field>
		<input
			matInput
			readonly
			(click)="dp.open()"
			formControlName="date"
			[matDatepicker]="dp"
			placeholder="Date"
		/>
		<mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
		<mat-datepicker #dp></mat-datepicker>
		<mat-hint *ngIf="!form.get('date').value"
			>Date cannot be before today.</mat-hint
		>
		<mat-error *ngIf="form.get('date').hasError('required')"
			>This field is required.</mat-error
		>
		<mat-error *ngIf="form.get('date').hasError('valueBeforeToday')"
			>Date cannot be before today.</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<textarea
			autocomplete="reason"
			rows="2"
			matInput
			placeholder="Reason"
			formControlName="reason"
		>
		</textarea>
	</mat-form-field>
</div>
